/**
 * Will link to the Online Bill Pay version of the portal
 * This will allow paying an arbitrary amount towards an account tied to a location
 * @param requestId - a unique idenitifer tied to a location
 */

import { useMatch } from '@tanstack/react-location';
import { WeaveBillPay } from '../../pages';

export const WeaveBillPayPortal = () => {
  const { params } = useMatch();
  const { requestId } = params;
  return <WeaveBillPay locationSlug={requestId || ''} />;
};
